import { Pipe, PipeTransform } from '@angular/core';
import {
  FeatureType,
  UserAccessService,
  UserAccessStatus,
} from '../../../../../user/access/user-access.service';

@Pipe({
  name: 'isFeatureAccessible',
})
export class IsFeatureAccessiblePipe implements PipeTransform {
  constructor(private accessService: UserAccessService) {}

  // _accessStatus is intentionally unused — passing it as an argument is the only
  // way to make Angular re-evaluate this pure pipe when the subscription status
  // changes. Removing it will silently freeze access gating after plan updates.
  transform(feature: FeatureType, _accessStatus: UserAccessStatus | null): boolean {
    return this.accessService.userHasAccess(feature);
  }
}
